import formAPIModelbloodpressure from "./bloodpressures";
import formAPIModelbodytempurature from "./bodytemperatures";
import formAPIModelfastingbloodglucose from "./fastingsugars";
import formAPIModelheight from "./heights";
import formAPIModeloxygensaturation from "./oxygensaturations";
import formAPIModelpostprandialbloodglucose from "./postsugars";
import formAPIModelpulse from "./pulses";
import formAPIModelrespiratoryrate from "./respiratoryrates";
import formAPIModelweight from "./weights";

export default function formapimodalvitals({
  bloodpressure,
  bodymassindex,
  bodytemperature,
  height,
  oxygensaturation,
  pulse,
  respiratoryrate,
  weight, 
  fastingbloodglucose,
  postprandialbloodglucose
}, type)
{
return Object.freeze({
    bloodpressure:bloodpressure !== null ? formAPIModelbloodpressure(bloodpressure,type) : [],    
    bodytemperature: bodytemperature !== null ? formAPIModelbodytempurature(bodytemperature, type) : [],
    height : height != null ?  formAPIModelheight(height, type):[],
    oxygensaturation : oxygensaturation !== null ? formAPIModeloxygensaturation(oxygensaturation, type) : [],
    pulse: pulse !== null ? formAPIModelpulse(pulse, type) : [],
    respiratoryrate: respiratoryrate !== null ? formAPIModelrespiratoryrate(respiratoryrate, type) : [],
    fastingbloodglucose: fastingbloodglucose !== null ? formAPIModelfastingbloodglucose(fastingbloodglucose, type) : [],
    postprandialbloodglucose: postprandialbloodglucose !== null ? formAPIModelpostprandialbloodglucose(postprandialbloodglucose, type) : [],
    weight:weight !== null ? formAPIModelweight(weight, type) : [],
    bodymassindexvalue: bodymassindex,
    bodymassindex:
      bodymassindex != null
        ? bodymassindex < 18.5
          ? parseInt((bodymassindex / 18.5) * 25)
          : bodymassindex <= 24.9
          ? parseInt(((bodymassindex - 18.5) / (24.9 - 18.5)) * 25 + 25)
          : bodymassindex <= 29.9
          ? parseInt(((bodymassindex - 25) / (29.9 - 25)) * 25 + 50)
          : parseInt(((bodymassindex - 30) / (100 - 30)) * 25 + 75)
        : "0",
    rotateangle:
      bodymassindex != null && bodymassindex < 18.5
        ? '-60'
        : bodymassindex != null && bodymassindex >= 18.5 && bodymassindex <= 24.9
        ? '0'
        : bodymassindex != null && bodymassindex >= 25 && bodymassindex <= 29.9
        ? '55'
        : '110',
});
}